/** Shared name/autocomplete token — isolates native browser history from generic `search-input` fields elsewhere. */
export const WORK_AREA_SEARCH_FIELD_NAME = 'work-area-contact-search';
export const WORK_AREA_SEARCH_AUTOCOMPLETE = 'work-area-contact-search';

export const WORK_AREA_HEADER_SEARCH_FIELD_ID = 'work-area-contact-search';
export const WORK_AREA_MODAL_SEARCH_FIELD_ID = 'work-area-modal-contact-search';
